import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import {
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import "./I18";
import { initI18 } from "./I18";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { LoadingScreen } from "./objects/DatabaseHandler";

import "firebase/compat/database";


const Admin = React.lazy(() => import("./pages/admin/Admin"));
const Faq = React.lazy(() => import("./pages/contact/Faq"));
const Contact = React.lazy(() => import("./pages/contact/Contact"));
const MiddlePage = React.lazy(() => import("./pages/booking/MiddlePage"));
const BookingPage = React.lazy(() => import("./pages/booking/BookingPage"));
const ToS = React.lazy(() => import("./pages/tos/ToS"));
const Cookies = React.lazy(() => import("./pages/tos/Cookies"));
const Company = React.lazy(() => import("./pages/contact/Company"));
const CheckoutPage = React.lazy(
  () => import("./pages/booking/CheckoutPage")
);
const ConfirmBooking = React.lazy(
  () => import("./pages/booking/UserInformationPage")
);
const Confirm = React.lazy(() => import("./pages/booking/ConfirmationPage"));
const Home = React.lazy(() => import("./pages/Home"));

function App() {
  return (
    <Router>
      <Routes>
        <Route
          element={
            <React.Suspense fallback={<LoadingScreen />}>
              <Layout />
            </React.Suspense>
          }
        >
          <Route path={"/admin"} element={<Admin />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/kontakta" element={<Contact />} />
          <Route path="/boka" element={<MiddlePage />} />
          <Route path={"/boka/:course"} element={<BookingPage />} />
          <Route path="/tos" element={<ToS />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/foretag" element={<Company />} />
          <Route path="/bekrafta" element={<ConfirmBooking />} />
          <Route path="/bekraftelse" element={<CheckoutPage />} />
          <Route path="/bekraftelse/:sessionid" element={<CheckoutPage />} />
          <Route path="/bokningsbekraftelse" element={<Confirm />} />
          <Route path="/home" element={<Home />} />
          <Route path="/hem" element={<Home />} />
          <Route path="/" element={<Home />} />
        </Route>
      </Routes>
    </Router>
  );
}



function Layout() {
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 100 + 500 * Math.random());

    window.scrollTo(0, 0);
  }, [pathname]);

  const [langLoaded, setLangLoaded] = useState(false);

  useEffect(() => {
    async function loadLang() {
      await initI18();
    }
    if (!langLoaded) loadLang().then(() => setLangLoaded(true));
  }, []);

  if (!langLoaded) return <LoadingScreen />;

  if (loading) return <LoadingScreen />;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: "100vh",
      }}
    >
      <Header />
      <Outlet />
      <Footer />
    </Box>
  );
}

export default App;
